import skillCategoryApi from "../../api/rest/skillCategoryApi";
import {ALERT_VARIANT} from "../../const/dataEnum";
import {setAlert} from "../actions/alertModalStateAction";

const deleteCategory = (category) => async (dispatch) => {
  const res = await skillCategoryApi.deleteCategory(category);
  let errorMessage = 'Something went wrong';

  if (res) {
    if (res?.responseCode === 0) {
      return true;
    }
    errorMessage = res.message;
  }

  dispatch(setAlert({
    show: true,
    variant: ALERT_VARIANT.ERROR,
    message: errorMessage,
  }));
  return false;
}

const skillCategoryBusiness = {
  deleteCategory,
};

export default skillCategoryBusiness;